import { PROFILE } from './constants';

export const permissionPerRoute = {
  Dashboard: [PROFILE.admin, PROFILE.financial],
  AdminUsers: [PROFILE.admin],
  AdminUsersCreate: [PROFILE.admin],
  AdminUsersEdit: [PROFILE.admin],
  Consumers: [PROFILE.admin],
  Traders: [PROFILE.admin],
  Partners: [PROFILE.admin],
  Users: [PROFILE.admin, PROFILE.financial, PROFILE.operations, PROFILE.head_operation],
  Investors: [PROFILE.admin],
  UserProfileEditProfile: [PROFILE.admin],
  UserProfileEditUser: [PROFILE.admin],
  ConsumerDataUser: [PROFILE.admin],
  InvoicesDataProfile: [PROFILE.admin],
  InstallationAccount: [PROFILE.admin],
  InstallationEdit: [PROFILE.admin],
  Faqs: [PROFILE.admin],
  InstallationReview: [PROFILE.admin, PROFILE.operations, PROFILE.head_operation],
  Installation: [PROFILE.admin, PROFILE.operations, PROFILE.head_operation],
  CurrentInstallation: [PROFILE.admin, PROFILE.financial, PROFILE.operations, PROFILE.head_operation],
  PanoramaCustom: [PROFILE.admin],
  Panorama: [PROFILE.admin, PROFILE.financial, PROFILE.operations, PROFILE.head_operation],
  NewPanorama: [PROFILE.admin, PROFILE.financial, PROFILE.operations, PROFILE.head_operation],
  Billing: [PROFILE.admin, PROFILE.financial, PROFILE.operations, PROFILE.head_operation],
  Loggers: [PROFILE.admin],
  FaqCreate: [PROFILE.admin],
  FaqEdit: [PROFILE.admin],
  Coupons: [PROFILE.admin],
  CouponCreate: [PROFILE.admin],
  CouponEdit: [PROFILE.admin],
  Contracts: [PROFILE.admin],
  ContractCreate: [PROFILE.admin],
  ContractEdit: [PROFILE.admin],
  Cooperatives: [PROFILE.admin],
  CooperativeCreate: [PROFILE.admin],
  CooperativeEdit: [PROFILE.admin],
  Investments: [PROFILE.admin],
  InvestimentCreate: [PROFILE.admin],
  InvestimentEdit: [PROFILE.admin],
  InvestimentInvestors: [PROFILE.admin],
  Commissions: [PROFILE.admin],
  CooperativeMembersDetails: [PROFILE.admin],
  CooperativeMembersCreate: [PROFILE.admin],
  CooperativeMembersEdit: [PROFILE.admin],
  CouponOwnersDetails: [PROFILE.admin],
  CouponOwnersCreate: [PROFILE.admin],
  CouponOwnersEdit: [PROFILE.admin],
  Notifications: [PROFILE.admin],
  Distributors: [PROFILE.admin],
  DistributorCreate: [PROFILE.admin],
  DistributorEdit: [PROFILE.admin],
  Covenant: [PROFILE.admin],
  CovenantCreate: [PROFILE.admin],
  CovenantEdit: [PROFILE.admin],
  PowerPlants: [PROFILE.admin],
  PowerPlantsCreate: [PROFILE.admin],
  PowerPlantsEdit: [PROFILE.admin],
  PowerPlantDetails: [PROFILE.admin],
  PowerPlantDataCreate: [PROFILE.admin],
  PowerPlantDataEdit: [PROFILE.admin],
  UserSalesComissions: [PROFILE.admin],
  UserBonuses: [PROFILE.admin],
  UserSalesComissionsReport: [PROFILE.admin],
  UserInstallationDiscounts: [PROFILE.admin],
  DefaultDiscounts: [PROFILE.admin],
  Calculation: [PROFILE.admin],
  OverdueInvoice: [PROFILE.admin, PROFILE.sales, PROFILE.operations, PROFILE.head_operation],
  LeadsExtract: [PROFILE.admin],
  Leads: [PROFILE.admin],
  LeadsQualified: [PROFILE.admin],
  LeadsReport: [PROFILE.admin],
};

export const hasPermissionToAccess = (profile, route) => {
  const requiredPermissions = permissionPerRoute[route];

  return requiredPermissions.includes(profile);
};

export const getFirstRouteWithAccess = profile => {
  for (const routeName in permissionPerRoute) {
    if (permissionPerRoute[routeName].includes(profile)) {
      return routeName;
    }
  }
  return null;
};
